import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import ScrollToTop from "@/components/ScrollToTop";
import SEO from "@/components/SEO";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Pricing from "@/pages/Pricing";
import CoursePage from "@/pages/CoursePage";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import SignupWizard from "@/pages/SignupWizard";
import KayitForm from "@/pages/KayitForm";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import { BlogList, BlogDetail } from "@/pages/Blog";
import KayitEvraklari from "@/pages/KayitEvraklari";
import LandingPage from "@/pages/LandingPage";
import ApplicationFlow from "@/pages/ApplicationFlow";

import SubscriberPopup from "@/components/SubscriberPopup";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";

function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <LocalBusinessSchema/>
      <Navbar/>
      <main className="flex-1"><Outlet/></main>
      <Footer/>
      <StickyCTA/>
      <SubscriberPopup/>
    </div>
  );
}

function NoIndexLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO noIndex={true} title="Estem Sürücü Kursu" description=""/>
      <Navbar/>
      <main className="flex-1"><Outlet/></main>
      <Footer/>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop/>
        <Routes>
          <Route element={<Layout/>}>
            <Route path="/" element={<Home/>}/>
            <Route path="/hakkimizda" element={<About/>}/>
            <Route path="/kurslarimiz" element={<Courses/>}/>
            <Route path="/kurs/:slug" element={<CoursePage/>}/>
            <Route path="/fiyatlar" element={<Pricing/>}/>
            <Route path="/galeri" element={<Navigate to="/kurslarimiz" replace/>}/>
            <Route path="/sss" element={<FAQ/>}/>
            <Route path="/iletisim" element={<Contact/>}/>
            <Route path="/blog" element={<BlogList/>}/>
            <Route path="/blog/:slug" element={<BlogDetail/>}/>
            <Route path="/kayit-ol" element={<Navigate to="/basla" replace/>}/>
            {/* Eski site URL'leri → sıralama koruma yönlendirmeleri */}
            <Route path="/çalışmasaatlerimiz" element={<Navigate to="/iletisim" replace/>}/>
            <Route path="/calismaSaatlerimiz" element={<Navigate to="/iletisim" replace/>}/>
            <Route path="/eğitimsüreci" element={<Navigate to="/hakkimizda" replace/>}/>
            <Route path="/egitimsureci" element={<Navigate to="/hakkimizda" replace/>}/>
            <Route path="/kurumsal" element={<Navigate to="/hakkimizda" replace/>}/>
            <Route path="/kayiticingerekenler" element={<Navigate to="/basla" replace/>}/>
            <Route path="/kayit-evraklari" element={<KayitEvraklari/>}/>
            {/* Programmatic SEO landing pages */}
            <Route path="/:slug" element={<LandingPage/>}/>
          </Route>
          {/* noindex sayfalar */}
          <Route element={<NoIndexLayout/>}>
            <Route path="/giris" element={<Login/>}/>
            <Route path="/basla" element={<SignupWizard/>}/>
            <Route path="/basvurum/:rid" element={<ApplicationFlow/>}/>
            <Route path="/kayit" element={<KayitForm/>}/>
            <Route path="/panelim" element={<Dashboard/>}/>
            <Route path="/admin" element={<Admin/>}/>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
